(function(){
	window.onload =function(){
		jQuery(".cities-status").hide();		
	};
	
	jQuery(document).ready(function(){
		
		var is_pending =false;
		var request=0;
		var request_recorded=0;

		jQuery(".criteria-input").on("change",function(e){
			var checkedCats=[];

			e.preventDefault();
			
			request++;
				
			setTimeout(function(){
				request_recorded++;
				if (request == request_recorded){
					
					if (is_pending==false){
						is_pending =true;
					
						if (jQuery(".cities-results").css('display') !== 'none'){
							jQuery(".cities-results").fadeOut();
						}
					
					jQuery(".cities-status").fadeIn();
					
					/*Get all criteria inputs*/
					jQuery(".criteria-input:checked").each(function(){
						checkedCats.push(jQuery(this).val());
					});	
					
					jQuery(".criteria-input").prop("disabled",true);
					
					/*send to server to get cities*/
					jQuery.get(
						    ajaxurl,
						    {
						        'action': 'get_cities',
						        'data': checkedCats
						    },				    
						    function(response){
						            jQuery(".cities-results").html(jQuery(response));							
									jQuery(".cities-status").fadeOut();
									jQuery(".cities-results").fadeIn();
									jQuery(".criteria-input").prop("disabled",false);
									is_pending =false;
						        }
						);
					
					}
				}
				
			},1000)
			
		})
	
	});
}(jQuery))